export default "__VITE_PUBLIC_ASSET__e37f91e7__"